export const fastGamesTextContent = {
  headingText: "Fast Games",
  paraText:
    "GammaSlots offer a massive range of slot games tailored for your needs. From ideation to deployment, we offer custom games with highly innovative features that deliver immersive slot experiences.",
  btnText: "View All",
  fastGamesContent: [
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_01.webp",
      gameNameText: "Plinko Win",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_02.webp",
      gameNameText: "Aviatrix",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_03.webp",
      gameNameText: "European Roulette",
    },
    {
      gameImageSrc: "/assets/stock-img/fast_game_img_04.webp",
      gameNameText: "Aviator",
    },
  ],
};
